export default "__VITE_ASSET__CemL_YUJ__"